import React from 'react';
import Modal from './Modal';

export default function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title = 'Confirm',
  subtitle,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  busy = false,
  danger = false,
  children,
}) {
  return (
    <Modal
      open={open}
      onClose={busy ? undefined : onClose}
      eyebrow="Confirm"
      title={title}
      subtitle={subtitle}
      footer={
        <div className="confirm-actions">
          <button className="btn btn--ghost" type="button" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={`btn ${danger ? 'btn--danger' : 'btn--primary'}`}
            type="button"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Please wait…' : confirmLabel}
          </button>
        </div>
      }
    >
      {children}
    </Modal>
  );
}
